(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["audio-cassette-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('audio-cassette-carousel')) {
    class AudioCassetteCarousel extends HTMLElement {
      static editorEventsBound = false;

      connectedCallback() {
        if (this.initialized) return;

        this.items = Array.from(this.querySelectorAll('[data-item]'));
        if (!this.items.length) return;

        this.previousButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.activeTitle = this.querySelector('[data-active-title]');
        this.activeDescription = this.querySelector('[data-active-description]');
        this.staticMode = this.dataset.staticMode === 'true';
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.activeIndex = this.getInitialIndex();

        this.bindItemEvents();
        this.bindControls();
        this.bindKeyboard();
        this.update();

        this.initialized = true;
        AudioCassetteCarousel.bindEditorEvents();
      }

      disconnectedCallback() {
        this.stopAll();
      }

      getInitialIndex() {
        const parsedIndex = Number.parseInt(this.dataset.initialIndex, 10);
        if (Number.isNaN(parsedIndex)) return 0;
        if (parsedIndex < 0) return 0;
        if (parsedIndex >= this.items.length) return 0;
        return parsedIndex;
      }

      bindItemEvents() {
        this.items.forEach((item, index) => {
          item.querySelector('[data-focus-button]')?.addEventListener('click', () => {
            this.setActive(index, { focus: false });
          });

          item.querySelector('[data-play-button]')?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.toggleAudio(index);
          });

          item.querySelector('[data-audio]')?.addEventListener('play', () => {
            this.handleAudioPlay(index);
          });

          item.querySelector('[data-audio]')?.addEventListener('pause', () => {
            this.syncPlayButtons();
          });

          item.querySelector('[data-audio]')?.addEventListener('ended', () => {
            this.syncPlayButtons();
          });
        });
      }

      bindControls() {
        this.previousButton?.addEventListener('click', () => {
          this.move(-1);
        });

        this.nextButton?.addEventListener('click', () => {
          this.move(1);
        });
      }

      bindKeyboard() {
        this.addEventListener('keydown', (event) => {
          if (this.staticMode || this.items.length < 2) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(1);
          }
        });
      }

      move(step) {
        if (this.items.length < 2) return;
        const nextIndex = (this.activeIndex + step + this.items.length) % this.items.length;
        this.setActive(nextIndex, { focus: true });
      }

      setActive(index, options = {}) {
        if (index < 0 || index >= this.items.length) return;

        const focus = options.focus === true;
        const shouldStop = options.stop !== false;
        const hasChanged = this.activeIndex !== index;

        const applyState = () => {
          if (hasChanged && shouldStop) {
            this.stopAll(index);
          }

          this.activeIndex = index;
          this.update();
        };

        if (hasChanged && document.startViewTransition && !this.prefersReducedMotion) {
          document.startViewTransition(applyState);
        } else {
          applyState();
        }

        if (focus) {
          this.items[index].querySelector('[data-focus-button]')?.focus();
        }
      }

      update() {
        const previousIndex = (this.activeIndex - 1 + this.items.length) % this.items.length;
        const nextIndex = (this.activeIndex + 1) % this.items.length;

        this.items.forEach((item, index) => {
          let position = 'hidden';

          if (index === this.activeIndex) {
            position = 'active';
          } else if (!this.staticMode) {
            if (this.items.length === 2) {
              const secondaryPosition = this.activeIndex === 0 ? 'next' : 'previous';
              const secondaryIndex = this.activeIndex === 0 ? 1 : 0;
              if (index === secondaryIndex) position = secondaryPosition;
            } else {
              if (index === previousIndex) position = 'previous';
              if (index === nextIndex) position = 'next';
            }
          }

          item.dataset.position = position;
          item.setAttribute('aria-hidden', position === 'hidden' ? 'true' : 'false');

          const focusButton = item.querySelector('[data-focus-button]');
          const playButton = item.querySelector('[data-play-button]');
          const visible = position !== 'hidden';
          const active = position === 'active';

          if (focusButton) {
            focusButton.setAttribute('aria-pressed', active ? 'true' : 'false');
            focusButton.tabIndex = visible ? 0 : -1;
          }

          if (playButton && !playButton.disabled) {
            playButton.tabIndex = active ? 0 : -1;
          }
        });

        this.updateDetails();
        this.syncPlayButtons();
      }

      updateDetails() {
        const activeItem = this.items[this.activeIndex];
        if (!activeItem) return;

        if (this.activeTitle) {
          this.activeTitle.textContent = activeItem.dataset.title || '';
        }

        if (this.activeDescription) {
          const description = activeItem.dataset.description || '';
          this.activeDescription.textContent = description;
          this.activeDescription.hidden = description.length === 0;
        }
      }

      toggleAudio(index) {
        const item = this.items[index];
        const audio = item?.querySelector('[data-audio]');
        if (!audio || !audio.src) return;

        this.setActive(index, { focus: false });

        if (audio.paused) {
          this.stopAll(index);
          audio.play().catch(() => {});
        } else {
          audio.pause();
        }
      }

      handleAudioPlay(index) {
        this.setActive(index, { stop: false, focus: false });
        this.stopAll(index);
        this.syncPlayButtons();
      }

      stopAll(exceptIndex = null) {
        this.items.forEach((item, index) => {
          if (index === exceptIndex) return;

          const audio = item.querySelector('[data-audio]');
          if (!audio) return;

          audio.pause();

          try {
            audio.currentTime = 0;
          } catch (error) {}
        });

        this.syncPlayButtons();
      }

      syncPlayButtons() {
        this.items.forEach((item) => {
          const title = item.dataset.title || 'Extrait audio';
          const audio = item.querySelector('[data-audio]');
          const playButton = item.querySelector('[data-play-button]');
          const playLabel = item.querySelector('[data-play-label]');
          const isPlaying = Boolean(audio && !audio.paused && !audio.ended);
          const label = isPlaying ? `Mettre en pause l'extrait ${title}` : `Lire l'extrait ${title}`;

          if (!playButton) return;

          playButton.dataset.playing = isPlaying ? 'true' : 'false';
          playButton.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
          playButton.setAttribute('aria-label', label);

          if (playLabel) {
            playLabel.textContent = label;
          }
        });
      }

      static bindEditorEvents() {
        if (this.editorEventsBound || !window.Shopify || !window.Shopify.designMode) return;

        document.addEventListener('shopify:block:select', (event) => {
          const carousel = event.target.closest('audio-cassette-carousel');
          const item = event.target.closest('[data-item]');
          if (!carousel || !item) return;

          const index = Number.parseInt(item.dataset.index, 10);
          if (Number.isNaN(index)) return;

          carousel.setActive(index, { focus: true });
        });

        this.editorEventsBound = true;
      }
    }

    customElements.define('audio-cassette-carousel', AudioCassetteCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
